import { useCallback } from 'react';
import { useGetHasProductV2 } from './useGetHasProduct.hook';
import { ProductType } from '@/@types/product';
import { report } from '@/tracking/tracking';
import { TrackingEvent } from '@/@types/trackingEvent';

export const useReportTrackingTenant = () => {
  const { hasProduct: hasWohnenPlus = false, isloading = false } = useGetHasProductV2(ProductType.WohnenPlus) || {};

  const reportTenantTracking = useCallback(
    (event: TrackingEvent) => {
      if (isloading) return;
      report(event, hasWohnenPlus);
    },
    [hasWohnenPlus, isloading],
  );

  return {
    reportTenantTracking,
  };
};
